export * from './VoiceList.container'



// WEBPACK FOOTER //
// src/features/Voices/VoiceList/index.ts